import React, { useState, useEffect, Fragment } from "react";
import useDropdownPosition from "../../../hooks/Dropdown/useDropDownPosition";
import useDebounce from "../useDebounce";

const OwnerDropDown = ({
  tableidclass,
  fetchPersonInTable,
  setDataInputRow,
  dataInputRow,
  SpecificElement,
  DropData,
  UpdateTableField,
  FieldValue,
  Item,
  handleInsert,
  owner,
  fieldname,
  handlePersonData,
  handleSaveData,
  disableVScroll,
}) => {
  const parsedDropData = Array.isArray(DropData) ? DropData : [];
  const [selected, setSelected] = useState({ email: "" });
  const [filter, setFilter] = useState(FieldValue?.value || "");
  const [show, setShow] = useState(true);

  useEffect(() => {
    setSelected({
      email: owner,
    });
  }, [owner]);

  const [focusedOptionIndex, setFocusedOptionIndex] = useState(null);
  const [hoveredItemPosition, setHoveredItemPosition] = useState({ x: 0, y: 0 });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const debouncedFilter = useDebounce(filter, 300);
  const { dropdownPosition, dropdownRef } = useDropdownPosition(show, tableidclass);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (show) {
      setIsLoading(true);
      setError(null);
      fetchPersonInTable(debouncedFilter);
      setIsLoading(false);
    }
  }, [debouncedFilter, show]);

  const close = () => {
    setShow(false);
    setFocusedOptionIndex(null);
  };

  const open = () => {
    setShow(true);
    setFilter("");
  };

  const filteredOptions = () => {
    return parsedDropData.filter((option) => {
      return (
        option.name?.toLowerCase().includes(filter?.toLowerCase()) ||
        option.email?.toLowerCase().includes(filter?.toLowerCase())
      );
    });
  };

  const onOptionClick = (index) => {
    setFocusedOptionIndex(index);
    selectOption(index);
  };

  const selectOption = (index) => {
    if (!isOpen) {
      return;
    }
    const focusedOption = filteredOptions()[index];
    if (focusedOption) {
      handleInsert(focusedOption.email, focusedOption.name, focusedOption.id);
      if (handleSaveData) {
        handleSaveData(focusedOption);
      }
      setSelected(focusedOption);
      if (handlePersonData !== undefined) {
        handlePersonData(focusedOption);
      }

      setFilter(`${focusedOption.email}`);
      close();
      setIsOpen(false);
    }
  };

  const handleKeyDown = (e) => {
    setIsOpen(true);
    switch (e.key) {
      case "Enter":
        selectOption(focusedOptionIndex);
        break;
      case "ArrowUp":
        // logic to focus previous option
        break;
      case "ArrowDown":
        // logic to focus next option
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close the dropdown if clicked outside
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false); // Close dropdown
      }
    };

    // Add event listener to close dropdown on outside click
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Fragment>
      <div className="" ref={dropdownRef}>
        <div className="relative">
          <div onClick={() => setShow(false)} className="bg-white flex rounded">
            <input
              name={fieldname || ""}
              value={selected ? selected.email : filter}
              placeholder="Email"
              onChange={(e) => {
                setFilter(e.target.value);
                setSelected(null);
              }}
              className="bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B active:border active:border-DFE2E5 text-gray-900 text-xs block w-full h-7.5 px-2"
              onClick={(e) => {
                e.stopPropagation();
                setShow(true);
              }}
              onKeyUp={handleKeyDown}
              autocomplete={disableVScroll ? "off" : ""}
            />
          </div>
          {isOpen && (
            <div
              className={`absolute shadow bg-white z-40 rounded max-h-[100px] overflow-y-auto  w-full thinscrollbar ${dropdownPosition === "bottom" ? "top-full mt-2" : "bottom-full mb-2"} ${disableVScroll && "overflow-x-hidden"}`}
            >
              <div className="flex flex-col w-full">
                {filteredOptions().length > 0 ? (
                  filteredOptions().map((option, index) => (
                    <div
                      key={index}
                      onClick={() => onOptionClick(index)}
                      onMouseEnter={(e) => {
                        setFocusedOptionIndex(index);
                        setHoveredItemPosition({ x: e.clientX, y: e.clientY });
                      }}
                      onMouseLeave={() => setFocusedOptionIndex(null)}
                      className={`flex w-full items-center p-2 pl-2 border-transparent border-l-2 relative hover:border-teal-100 ${
                        focusedOptionIndex === index ? "bg-gray-100" : ""
                      }`}
                      aria-selected={focusedOptionIndex === index}
                    >
                      <div className="w-full items-center flex">
                        <div className="mx-2 -mt-1">
                          <span className="text-2999BC">{option?.name}</span>
                          <div className="text-xs truncate w-full normal-case font-normal -mt-1 text-gray-500">
                            {option?.email}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="p-2 text-gray-500 text-sm">No data found</div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default OwnerDropDown;
